import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from 'swiper';
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";
import { StaffList } from "../../constants/staff";

export default function Team() {
    const [arrow, setArrow] = useState(false);
    const [swiperInstance, setSwiperInstance] = useState<SwiperType | null>(null);

    useEffect(() => {
        const updateArrowSize = () => {
            if (window.innerWidth <= 800) {
                setArrow(true);
            } else {
                setArrow(false);
            }
        };

        updateArrowSize();
        window.addEventListener("resize", updateArrowSize);

        return () => window.removeEventListener("resize", updateArrowSize);
    }, []);

    const handleSlideClick = (index: number) => {
        if (swiperInstance) {
            swiperInstance.slideToLoop(index);
        }
    };

    return (
        <div className='relative w-full bg-white'>
            {/* <img src="/title/line.webp" alt="" className="mt-8 lg:mt-14 w-[45%] h-1.5 lg:h-2 lg:w-2/5" /> */}
            <div className='w-[94%] lg:w-[80%] mx-auto relative'>
                {/* <img src="/title/fonTeam.webp" alt="" className="w-[60%] h-[30%] lg:w-[75%] absolute left-[20%] top-[35%] lg:left-[12%] lg:top-[20%] lg:h-[42%]" /> */}
                <h1 className='text-[27px] lg:text-[42px] 2xl:text-[50px] text-[#273167] font-bold mt-4 2xl:mt-7'>
                    Наша команда
                </h1>
                <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                    speed={1000}
                    centeredSlides={true}
                    onSwiper={(swiper: SwiperType) => setSwiperInstance(swiper)}
                    breakpoints={{
                        320: { slidesPerView: 3 },
                        1024: { slidesPerView: 5 },
                    }}
                    className="px-3 lg:px-7 2xl:px-10 my-5 lg:my-10 2xl:my-14 md:h-40 lg:h-[240px] 2xl:h-[370px]"
                >
                    {StaffList.map((item, index) => (
                        <SwiperSlide
                            key={index}
                            className="aspect-[5/7] px-4 py-9 lg:py-14 2xl:py-16"
                            onClick={() => handleSlideClick(index)}
                        >
                            {({ isActive }) => (
                                <div className={`relative flex flex-col items-center transition-transform duration-1000 ${isActive ? "scale-150" : "scale-110"} cursor-pointer`}>
                                    <img
                                        src={item.img}
                                        alt={`ura ${index + 1}`}
                                        className={`drop-shadow-md rounded-[4px] lg:rounded-md w-full h-auto object-cover aspect-[5/7] max-w-[50px] lg:max-w-[95px] 2xl:max-w-[130px]`}
                                    />
                                    <div className="text-center mt-0.5 lg:mt-1">
                                        <h3 className="text-[#273167] text-[8px] lg:text-sm 2xl:text-base font-medium lg:font-semibold">{item.name}</h3>
                                        <p className="text-[#273167] text-[6px] lg:text-[10px] 2xl:text-xs mt-0.5 lg:mt-1 h-10">{item.post}</p>
                                    </div>
                                </div>
                            )}
                        </SwiperSlide>
                    ))}
                    <div className={`swiper-button-next custom-arrow pb-16 ${!arrow ? "opacity-100" : "opacity-0"}`} style={{ width: '10px', height: '50px', color: '#273167' }}></div>
                    <div className={`swiper-button-prev custom-arrow pb-16 ${!arrow ? "opacity-100" : "opacity-0"}`} style={{ width: '10px', height: '50px', color: '#273167' }}></div>
                </Swiper>
            </div>
        </div>
    )
}